<template>
  <div class="row">
    <div class="col">
      <card-container
              :title="$router.currentRoute.meta.title"
              :headers="tableHeaders"
              :lastPage="lastPage"
              :totalElements="totalElements"
              :currentPage="getCurrentPage()"
              :clickHandler="pagination">

    
        <template v-slot:card-header>
           <router-link :to="{ name: `${captainBonusesRoutePrefix}.index`}"  class="btn btn-primary btn-sm">
             <i class="fa fa-arrow-left"></i>
           </router-link>
        </template>
        <template v-slot:table-rows>
          <tr v-for="item in items" :key="item.id">
            <td> {{ item.id }} </td>
            <td> {{ item.captainId }} </td>
            <td class="text-direction-ltr"> {{ item.createdAt | moment("Y-MM-DD hh:mm:ss A") }} </td>
          </tr>
          <tr class="text-center" v-if="!items.length">
            <td colspan="999">{{ $t('messages.no_result_found')}}</td>
          </tr>
        </template>
      </card-container>
    </div>
  </div>
</template>
<script>

  import { CAPTAIN_BONUSES_LOGS_LIST as CRUD_ACTION_LIST} from 'actions/captain_bonuses';
  const CAPTAIN_BONUSES_CODE="captain_bonuses";
  const CRUD_CODE=`${CAPTAIN_BONUSES_CODE}.logs`;
  const CRUD_PERMISSION_CODE=`${CAPTAIN_BONUSES_CODE}`;
  export default {
    name: "CaptainBonusLogIndex",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_PERMISSION_CODE,
        captainBonusesRoutePrefix: CAPTAIN_BONUSES_CODE,
        captainBonusesTransPrefix: CAPTAIN_BONUSES_CODE,
        id:this.$router.currentRoute.params.id,
        tableHeaders:[
          {
            'title':`fields.id`
          },
          {
            'title':`fields.captain_id`
          },
          {
            'title':`fields.created_at`
          }
        ],
        items: [],
        perPage:20,
        totalElements:0,
        lastPage:0
      }
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(){
        this.$store.dispatch(CRUD_ACTION_LIST,{
          pageId: this.getCurrentPage()-1,
          bonusId: this.id,
        }).then(response=>{
          this.items=response.data.data;
          this.perPage=response.data.perPage;
          this.totalElements=response.data.totalElements;
          this.lastPage=response.data.pageCount;
        });
      },
      pagination(page){
        if(page!== this.getCurrentPage()){
          this.$router.push({
            name: `${this.routePrefix}.index`,
            query:{
              page
            }
          });
          this.getList();
        }
      },
      getCurrentPage(){
        let currentPage=this.$route.query.page??1;
        return parseInt(currentPage>=1?currentPage:1);
      },
    }
  };
</script>
